module.exports = __webpack_public_path__ + "img/10.533d3516.png";